module.exports = __webpack_public_path__ + "img/saas.032ed33f.png";